<template>
  <div id="orario" v-if="this.membersOK  && parametersOpen">
    <div class="surtitre" style="padding-top: 20px">
      <router-link to="/annuario/">Annuario</router-link>
    </div>
    <div class="titre-principal centre" style="padding-bottom: 20px">
      Listing per Lingua
    </div>
    <div style="margin: 0 5px 80px 5px;">
      <template 
        v-for="(lingua, index) in this.lingueTab" 
          :key=index
          >
          <div v-if="lingua.horaire != '-----------'">
            <div v-if="linguaBreak(lingua.lingua)">
              <div class="jourLibelleCenter bordeaux">{{ this.$store.state.params['lingua'][lingua.lingua].toUpperCase() }}</div>
            </div>
            <!-- Jour de la semaine -->  
            <div v-if="jourBreak(lingua.giorno)">
              <div class="joursDeLaSemaine">{{ joursSemLibelle[lingua.giorno] }}</div>
            </div>
            <!-- Ligne -->
            <div class="ligneContainer backWhite borderNone minHeight0 p0 mT2" :class="apremBreak(lingua.horaire)">
              <div class="ligne-left flex">
                <div class="flex flex-align-center ligne-left">
                  {{ lingua.horaire }}
                </div>

                <!-- Nome penitenziere -->
                <div class="ligne-left">
                  <div class="nomePenitenziere flex p0  ">
                    <div :class="[ { bordeaux: lingua.tipo == 'agg'} ]"><span>{{ lingua.nome }} {{ lingua.cognome }}</span></div>
                    <!-- Confessionale per aggiunti -->
                    <div class="flex" v-if="this.$store.state.params['confessionale'][lingua.conf]">
                      <div class="confessionale m0 weightNormal">&nbsp;Confessionale di</div>
                      <div class="confessore bleuFonce right m0 p0">&nbsp;{{ this.$store.state.params['confessionale'][lingua.conf] }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

var bLingua = "";
var bJour = -1;
var bHoraire = "";
var horaire16Break = true;

export default {
  name: "listing-per-lingua",
  data() {
    return {
      lingueTab: [],
      membersOK: false,
      joursSemaine: [ "Lu", "Ma", "Me", "Gi", "Ve", "Sa", "Do" ],
      joursSemLibelle: [ "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica" ],
      ligneNome: "",
      confessionaux: [],
      horaireFirst: "",
      jBreak: false,
    }
  },
  computed: {
    ...mapState(["annuarioDB", "annuarioDBOpen", 'params', 'parametersOpen', "routerParams"]),
  },
  created() { 
    if (!this.parametersOpen) {
      console.log('parametres not open')
      var x = this.$store.dispatch("getParams")
      x.then( () => {
        console.log('params après x = ', this.$store.state.params )
        console.log('lingua ceca = ', this.$store.state.params['lingua']['cz']) 
      }) 
    } else { console.log('parametres déjà chargés')}

    console.log('debut chargeDatabase')
    if (!this.annuarioDBOpen) {
      console.log('annuariodb not chargé ', this.annuarioDB)
      this.$store.dispatch("getAnnuario") } 
    else { 
      this.createLingueTab() 
    }
  },
  watch: {
    annuarioDB: function() {

      this.createLingueTab()

    }
  },

  mounted() {
    this.$store.dispatch("setHighlight", { on: true }); // highlight the tab of tabMenu
  },

  unmounted() {
    this.$store.dispatch("setHighlight", { on: false }); // highlight the tab of tabMenu
  },

  methods: {

    setID(giorno) {
      return giorno.substring(0, 3)
    },

    apremBreak(horaire) {
      if ( horaire.substr(0, 2) >= "16" ) {
        if ( horaire16Break ) {
          horaire16Break = false
          return "separePointille" 
        }
      }
      else   {
        horaire16Break = true
        return ""
      }
    },

    linguaBreak(lingua) {
      if ( lingua != bLingua ) {
        bLingua = lingua 
        return true }
      else {
        return false
      }
    },

    jourBreak(giorno) {
      if ( giorno != bJour ) {
        bJour = giorno
        this.jBreak = true;
        return true }
      else {
        this.jBreak = false;
        return false
      }
    },

    horaireBreak(horaire) {
      if ( horaire != bHoraire ) {
        bHoraire = horaire
        let varToReturn = "<span class='horaireBackground ligneBreak'>" + horaire + "</span>"
        return varToReturn; }
      else {
        let varToReturn = "<span class='ligneNonBreak'></span>"
        return varToReturn; 
      }
    },

    goToAnchor(leJour, comportement) {
      console.log(leJour)
      let x = document.getElementById(leJour);
      x.scrollIntoView({ behavior: comportement, block: "start" });
    },

    createLingueTab() {

      for (let membro of this.annuarioDB[1]) {

        if ( membro.data_arrivo != '9999-99-99' && membro.attivo == 1 ) {

          console.log('membro = ', membro); 

          var theLingue = membro.lingue.split("-");
          console.log('theLingue = ', theLingue); 
          
          for (let theLingua of theLingue) {

            let lignes = membro.orari.split('\r\n')

            for (let ligne of lignes) {
              let matinSoir = ligne.split('/')
              let leMatin = matinSoir[0].split(':')
              let jour = this.joursSemaine.indexOf( leMatin[0] )
              let horaireMatinConfessional = leMatin[1].split('#')
              let horaireMatin = horaireMatinConfessional[0].trim()
              let horaireMatinConf = horaireMatinConfessional[1] ? horaireMatinConfessional[1].trim() : ""

              let lingua = {
                lingua: theLingua,
                nome: membro.nome,
                cognome: membro.cognome,
                tipo: membro.tipo,
                giorno: jour, 
                horaire: horaireMatin, 
                conf: horaireMatinConf,
              }
              this.lingueTab.push(lingua)

              let horaireSoirConfessional = matinSoir[1].split('#')
              let horaireSoir = horaireSoirConfessional[0].trim()
              let horaireSoirConf = horaireSoirConfessional[1] ? horaireSoirConfessional[1].trim() : ""
              
              lingua = {  
                lingua: theLingua,
                nome: membro.nome,
                cognome: membro.cognome,
                tipo: membro.tipo,
                giorno: jour, 
                horaire: horaireSoir, 
                conf: horaireSoirConf,
              } 
              this.lingueTab.push(lingua)
            }
            console.log('lingua = ', this.lingueTab)
          }
        }
      }
      // trier
      console.log("lingueTab avant tri = ", this.lingueTab )
      this.lingueTab.sort((a, b) => {
        // Comparer par langue
        if (a.lingua < b.lingua) return -1;
        if (a.lingua > b.lingua) return 1;

        // Comparer par jour de la semaine
        if (a.giorno < b.giorno) return -1;
        if (a.giorno > b.giorno) return 1;

        // Si les jours de la semaine sont identiques, comparer par horaire
        if (a.horaire < b.horaire) return -1;
        if (a.horaire > b.horaire) return 1;

        // Si les jours de la semaine et horaire sont identiques, comparer par tipo (descendant)
        if (a.tipo < b.tipo) return 1;
        if (a.tipo > b.tipo) return -1;

        // et enfin par nom
        if (a.nome < b.nome) return -1;
        if (a.nome > b.nome) return 1;

        // Si tout est identique
        return 0;
      });
      console.log('lingueTab à la fin = ', this.lingueTab)
      this.membersOK = true;
      console.log('memberOK = ', this.membersOK)
    }

  }
}

</script>

<style>
.horaireBackground { 
  padding: 4px;
  font-weight: bold;
	border: 1px solid #b8b8ff;  
	max-height: 23px;
	background-color: azure;
	border-radius: 10px; }
.ligneContainer { 
  display: flex; 
  justify-content: space-between;
  align-items: center;
  background-color: beige;
  border-bottom: 1px solid #a52a2a30;
  padding: 0 10px;
  border-radius: 7px;
  min-height: 25px; }
.ligne-left, .ligne-right {   
  text-align: left; 
  min-width: 77px;
  font-size: 12px;  }
.ligneBreak { display: block; min-width: 75px; }
.ligneNonBreak { margin-left: 75px; max-width: 75px; }
.ligneBreak span, .ligneNonBreak span { font-weight: bold; }
.ligneHoraire { margin-top: 5px; }
.nomePenitenziere { font-weight: bold; margin-left: 8px; padding: 5px 0; }
.nomePenitenziere span { margin-left: 3px;  }
.confessionale { margin: -5px 0 0 10px; }
.confessore { margin-top: -5px; padding-bottom: 5px; }
.m0 { margin: 0px; }
.mL10 { margin-left: 10px; }
.mT2 { margin-top: 2px; }
.mT5 { margin-top: 5px; }
.p0 { padding: 0; }
.pt10 { padding-top: 10px; }
.minHeight0 { min-height: 0; }
.weightNormal { font-weight: normal; }
.scrollMargin { scroll-margin-top: 2rem; }
.langues { font-size: 11px; font-weight: 400!important }
.bleuFonce { color: blue; font-weight: bold; }
.backWhite { background-color: white; }
.borderNone { border: none; }

.separePointille { 
  margin-top: 5px;
  padding-top: 5px;
  border-top: 1px dashed black;
  border-radius: 0;
}

.jourLibelle, .vaiSu { 
  text-align: left; 
  cursor: pointer;
  font-size: 16px; 
  font-weight: bold; 
  margin-top: 20px;
  padding: 0 5px; 
  scroll-margin-top: 5rem; 
}

.jourLibelleCenter {
  font-weight: bold;
  font-size: 20px;
  font-family: Oswald;
  text-align: center;
  margin-top: 20px;
}

.joursDeLaSemaine {
  margin-top: 5px;
  font-weight: bold;
  font-family: Oswald;
  text-align: left;
}

.joursDeLaSemaineOld {
  position: sticky;
  top: 0;
  display: flex; 
  justify-content: space-evenly;
  padding: 5px 10px;
  background-color: white;
}
.jourLink { 
  cursor: pointer;
  padding: 3px;
  background-color: rgb(123, 0, 0);
  border-radius: 20px;
  color: white; 
  width: 50px;
 }

</style>